import { extractFaqEntries } from 'helpers/parsing/extractFaqEntries';
import { extractYoutubeVideoId } from 'helpers/parsing/extractYoutubeVideoId';
import Head from 'next/head';
import { ArticleDetailType } from 'types/article';

type ArticleMetadataProps = {
    article: ArticleDetailType;
};

export const ArticleMetadata: FC<ArticleMetadataProps> = ({ article }) => {
    const youtubeVideoId = extractYoutubeVideoId(article.text);
    const videoObject = youtubeVideoId
        ? {
              '@context': 'https://schema.org/',
              '@type': 'VideoObject',
              name: article.articleName,
              thumbnailUrl: `https://img.youtube.com/vi/${youtubeVideoId}/hqdefault.jpg`,
              embedUrl: `https://www.youtube.com/embed/${youtubeVideoId}`,
          }
        : null;

    const jsonLdItems: object[] = [
        {
            '@context': 'https://schema.org/',
            '@type': 'Article',
            headline: article.articleName,
            datePublished: article.createdAt,
        },
    ];

    if (videoObject) {
        jsonLdItems.push(videoObject);
    }

    const faqEntries = article.text === null ? [] : extractFaqEntries(article.text);
    if (faqEntries.length > 0) {
        jsonLdItems.push({
            '@context': 'https://schema.org/',
            '@type': 'FAQPage',
            mainEntity: faqEntries,
        });
    }

    return (
        <Head>
            <script
                key="article-metadata"
                id="article-metadata"
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(jsonLdItems),
                }}
            />
        </Head>
    );
};
